import { useGlobalData } from "@/context/global";
import { useEffect } from "react";
import useSWR from "swr";
import store from "store";
import { useRouter } from "next/router";
import { getCookie } from "cookies-next";
import { tokenDecoder } from "@/utils/global";
import { getCategoryTree } from "@/services/category";

export function useCategoryTree() {
  const { locale } = useRouter();
  const { dispatch } = useGlobalData();
  const handshake = getCookie("handshake");

  const decodedToken = tokenDecoder(handshake);

  const { mutate } = useSWR(
    () => `/api/category/tree?locale=${locale}`,
    async () => {
      return await getCategoryTree(handshake);
    },
    
    {
      revalidateOnMount: false, // 30 minutes in milliseconds
      revalidateOnFocus: false,
      onSuccess: (data) => {
        dispatch({
          type: "get_ctree",
          payload: {
            ...(data?.data?.data || {}),
            cacheTime: Date.now() + 30 * 60 * 1000,
          },
        });
      },
    }
  );

  useEffect(() => {
    if (locale !== decodedToken?.storeName) {
      // console.log('11111')
      mutate();
      return;
    } else if (
      store.get("app_data")?.cacheTime > Date.now() &&
      locale === decodedToken?.storeName
    ) {
      // mutate();
      // console.log('22222')
      dispatch({
        type: "get_ctree",
        payload: {
          ...store.get("app_data")?.categoryData,
          cacheTime: store.get("app_data")?.cacheTime,
        },
      });
      return;
    } else {
      // console.log('33333')
      mutate();
    }
  }, [decodedToken?.storeName, dispatch, locale, mutate]);

  return null;
}
